module.exports = __webpack_public_path__ + "static/media/hrbp_doc1.7598ba3d.jpg";